import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { dynamicBaseQuery } from '~/api/common/dynamicBaseQuery';
import { AvailableAction } from '~/api/models/availableAction';
import { Stage } from '~/api/models/stage';

export const STAGE_TAG = 'stage';
export const stagesServiceApi = createApi({
    reducerPath: 'stagesApi',
    baseQuery: dynamicBaseQuery,
    tagTypes: ['stage'],
    endpoints: (builder) => ({
        createStage: builder.mutation<Stage, Stage>({
            query: (data) => ({
                url: '/v1/admin/stage',
                method: 'POST',
                body: data,
            }),
        }),
        editStage: builder.mutation<Stage, Stage>({
            query: (data) => {
                const { id, ...body } = data;
                return {
                    url: `/v1/admin/stage/${id}`,
                    method: 'PUT',
                    body: body,
                };
            },
            invalidatesTags: [STAGE_TAG],
        }),
        deleteStage: builder.mutation<void, number>({
            query: (id) => ({
                url: `/v1/admin/stage/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [STAGE_TAG],
        }),
        getStageAvailableActions: builder.query<AvailableAction[], number>({
            query: (id) => ({
                url: `/v1/admin/stage/${id}/available-actions`,
                method: 'GET',
            }),
            providesTags: [STAGE_TAG],
        }),

    })
});
export const {
    useCreateStageMutation,
    useEditStageMutation,
    useDeleteStageMutation,
    useGetStageAvailableActionsQuery,
} = stagesServiceApi;

